import { render, staticRenderFns } from "./PatientBedsoreList.vue?vue&type=template&id=5e645dbf&"
import script from "./PatientBedsoreList.vue?vue&type=script&lang=ts&"
export * from "./PatientBedsoreList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports